import { AuthFetchError, AuthFetchWithResponse } from '@e3dc-react/shell/Types/api'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'

export const toggleSmartMeterGatewayActivation = async (
  installationId: number,
  emcDeviceLinkId: string,
  isNewSmartMeterGateway: boolean,
  active: boolean,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${emcDeviceLinkId}/middlewares/smart-meter-gateway`,
      method: isNewSmartMeterGateway ? 'POST' : 'PUT',
      payload: { active },
    })

    if (response.status !== StatusCodes.OK && response.status !== StatusCodes.CREATED) {
      return new ApiResult<null, Error | AuthFetchError>(null, true)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to toggle smart meter gateway activation:')
  }
}

export const updateSmartMeterGatewayPairingId = async (
  installationId: number,
  emcDeviceLinkId: string,
  ski: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${emcDeviceLinkId}/middlewares/smart-meter-gateway`,
      method: 'PUT',
      payload: {
        ski: ski.replaceAll('-', ''),
      },
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null, true)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update smart meter gateway pairing ID:')
  }
}
